module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/contracts/remoteEntry.js';
            script.onload = () => { resolve(window['contracts']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module contracts unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });